import { Direccion } from "../direccion.interface"

export interface DireccionANormalizar {
    barrio: string,
    calle: string,
    localidad: string,
    altura: string,
    provincia: string
}

export const toDireccionANormalizar = ({ 
    barrio, calle, localidad, altura, provincia 
}: Direccion): DireccionANormalizar => ({ barrio, calle, localidad, altura, provincia })